import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ShipmentQuotation } from './shipment-relations.models';
import * as ShipmentRelationActions from './shipment-relations.actions';

export const SHIPMENTRELATIONS_FEATURE_KEY = 'shipmentRelations';

export interface State extends EntityState<ShipmentQuotation> {
    loading: boolean;
    error?: string | null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    quotation: any;
}

export interface ShipmentRelationsPartialState {
    readonly [SHIPMENTRELATIONS_FEATURE_KEY]: State;
}

export const shipmentRelationsAdapter: EntityAdapter<ShipmentQuotation> =
    createEntityAdapter<ShipmentQuotation>();

export const initialState: State = shipmentRelationsAdapter.getInitialState({
    loading: false,
    quotation: null,
});

export const shipmentRelationsReducer = createReducer(
    initialState,
    on(ShipmentRelationActions.init, state => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(
        ShipmentRelationActions.loadShipmentQuotationSuccess,
        (state, { quotation }) => {
            if (!quotation) {
                return { ...state, loading: false, error: null };
            }
            return shipmentRelationsAdapter.setOne(quotation, {
                ...state,
                quotation,
                loading: false,
                error: null,
            });
        }
    ),
    on(
        ShipmentRelationActions.loadShipmentQuotationFailure,
        (state, { error }) => ({ ...state, error, loading: false })
    ),
    on(ShipmentRelationActions.reset, () => initialState)
);

export function reducer(state: State | undefined, action: Action) {
    return shipmentRelationsReducer(state, action);
}
